import loadable from '@loadable/component';

const MonacoEditor = loadable(() => import('./[id]/page'));

export const routes = [
  {
    path: ':id',
    element: <MonacoEditor />,
  }
];